/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import ShopifyLogo from "@/app/components/icons/ShopifyLogo";
import LiquidLogo from "@/app/components/icons/liquidLogo";

export default function Prismpm() {
    const primaryColor = "#F3999B";
    useEffect(() => {
        const link = document.createElement("link");
        link.href =
            "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
        link.rel = "stylesheet";
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <>
            <section className="flex flex-col gap-[100px] my-[35px]">
                <div>
                    <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2FrossahutLogo.svg?alt=media&token=57abb4aa-752f-426b-a5de-eb4f8920bac7" />
                    <FirstBlockAbout
                        media={{
                            type: "image",
                            src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FrossaHut%2FrossahutBackground.png?alt=media&token=914fcc58-4b60-47e1-9b7f-72192e7e8e92",
                        }}
                        primaryColor={primaryColor}
                    />
                    <WebsiteSubtitle
                        text="We crafted a stunning new online presence for Rossahut, bringing their brand to life on Shopify with a bespoke design. Our work included a complete visual overhaul, ensuring a seamless and engaging shopping experience. The new Shopify store is designed for easy navigation and showcases their products beautifully. From the initial design concept to the final implementation on the Shopify platform, we focused on creating a website that not only looks fantastic but also drives sales."
                        title="Deliverables"
                        tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
                        buttonHref="https://rossahut.com/"
                    />
                </div>

                <PortfolioTypography
                    typographyData={[
                        {
                            headline:
                                "We deliver engaging online shopping experiences that beautifully showcase Rossahut's offerings.",
                            fontFamily: "Montserrat",
                            fontSize: "32px",
                            letterSpacing: "0%",
                            lineHeight: "auto",
                            textColor: "#2c2d2c",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioColorscheme
                    ColorschemeData={[
                        {
                            title: "Main color",
                            color: "#fff",
                            rgb: "#fff",
                            textColor: "#2c2d2c",
                        },
                        {
                            title: "Black",
                            color: "#2c2d2c",
                            rgb: "#2c2d2c",
                            textColor: "#FFFFFF",
                        },
                        {
                            title: "Light Pink",
                            color: "#F3999B",
                            rgb: "#F3999B",
                            textColor: "#FFFFFF",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioResponsiveDisplays
                    ResponsiveDisplaysData={[
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FrossaHut%2Frossahutpc.webp?alt=media&token=c415d2d3-13e9-49dd-bf28-a6afa6210f5b",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FrossaHut%2FrossahutIpad.webp?alt=media&token=61825469-f7e2-481a-8786-eb189395c26d",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FrossaHut%2FrossahutPhone.webp?alt=media&token=16f419f4-ce8c-403b-ae95-6103223a257b",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioTechStack
                    primaryColor={primaryColor}
                    blocks={[
                        {
                            title: "Design",
                            titleColor: "#2c2d2c",
                            icons: [<FigmaLogo />],
                            opacity: 5,
                        },
                        {
                            title: "Layout Development",
                            titleColor: "#2c2d2c",
                            icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
                            opacity: 15,
                        },
                        {
                            title: "Theme Development",
                            titleColor: "#2c2d2c",
                            icons: [<LiquidLogo />],
                            opacity: 25,
                        },
                        {
                            title: "Publishing",
                            titleColor: "#2c2d2c",
                            icons: [<ShopifyLogo />],
                            opacity: 30,
                        },
                    ]}
                />
            </section>
        </>
    );
}